/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import axios from "axios";
import config from "./../config";

export class Maintenance {
  static getMaintenance() {
    const url = process.env.NODE_ENV == "development" ?
      "http://10.252.25.208:8080/castlemock/mock/rest/project/TK8t3o/application/UXxhjW/getMaintenanceSchedules" :
      [config.basename, "api/schedule/getMaintenanceSchedules"].join("/");

    return axios.get(url);
  }

  static getDevicesFromSchedule(scheduleId) {
    const url = process.env.NODE_ENV == "development" ?
      "http://10.252.25.208:8080/castlemock/mock/rest/project/TK8t3o/application/UXxhjW/getComputerSytem_scheduleId" :
      [config.basename, `api/schedule/getComputerSystems?scheduleId=${scheduleId}`,].join("/");
    return axios.get(url);
  }

  static saveMaintenance(credentialObj) {
    return axios.post(
      [config.basename, "api/schedule/addMaintenanceSchedule"].join("/"),
      credentialObj
    );
  }

  static saveMaintenanceSystems(credentialObj) {
    return axios.post(
      [config.basename, "api/schedule/addMaintenanceSystems"].join("/"),
      credentialObj
    );
  }

  static editMaintenance(credentialObj) {
    return axios.post(
      [config.basename, "api/schedule/editMaintenanceSchedule"].join("/"),
      credentialObj
    );
  }

  static deleteMaintenance(id) {
    return axios.delete(
      [config.basename, "api/schedule/deleteMaintenanceSchedule/" + id].join(
        "/"
      )
    );
  }

  static deleteMaintenanceSystem(scheduleId) {
    return axios.delete(
      [
        config.basename,
        "api/schedule/removeMaintenanceSystems?scheduleId=" + scheduleId,
      ].join("/")
    );
  }

  static endMaintenance(scheduleId) {
    let requestBody = {
      schedule_id: scheduleId,
      hierarchy: "parent",
    };
    return axios.delete(
      [config.basename, "api/schedule/endMaintenance"].join("/"),
      { data: requestBody }
    );
  }

  static getTimeZones() {
    const url = process.env.NODE_ENV == "development" ?
      "http://10.252.25.208:8080/castlemock/mock/rest/project/TK8t3o/application/UXxhjW/getTimezones" :
      [config.basename, "api/schedule/getTimeZones"].join("/");

    return axios.get(url);
  }

  static getScheduleForDevices(csId) {
    var url = process.env.NODE_ENV == "development" ?
      'http://10.252.25.208:8080/castlemock/mock/rest/project/TK8t3o/application/UXxhjW/getScheduleForDevices' :
      [config.basename, `api/schedule/computerSystemMaintenanceSchedules/${csId}`,].join("/");

    return axios.get(url);
  }

  static removeDeviceForSchedule(scheduleId, csId) {
    return axios.get(
      [
        config.basename,
        `api/schedule/removeComputerSystemMaintenanceSchedule/${scheduleId}/${csId}`,
      ].join("/")
    );
  }
}
